<template>
    <header>
        <el-row :gutter="10" type="flex" align="middle">
            <div style="white-space: nowrap">TCA-ECADUS AWARD APPLICATIONS</div>
            <el-col :span="20" v-if="userLogged">
                <menubar />
            </el-col>
            <el-col :span="4" class="text-right" v-if="userLogged">
                <el-button @click.native="logout">Log Out</el-button>
            </el-col>
        </el-row>
    </header>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { TOGGLE_COLLAPSE } from "../../../core/store/types";
import Menubar from "./Menubar";

export default {
    data: () => ({
        sysUserName: "",
        sysUserAvatar: "",
    }),
    components: { Menubar },
    methods: {
        ...mapMutations([TOGGLE_COLLAPSE]),
        logout: function () {
            this.$auth.logout({
                makeRequest: true,
                redirect: { name: "admin-login" },
            });
        },
        collapse() {
            this[TOGGLE_COLLAPSE]();
        },
    },
    mounted() {
        const user = this.$auth.user();
        if (user) {
            this.sysUserName = user.name || "";
            this.sysUserAvatar = user.avatar || "";
        }
    },
    computed: {
        userLogged: function () {
            return this.$auth && this.$auth.user();
        },
        ...mapGetters(["coreIsCollapsed"]),
    },
};
</script>
